import axios from "axios";

const api = axios.create({
  baseURL:
    process.env.REACT_APP_API_URL ||
    "https://192.168.0.6:3000",
  withCredentials: true,
});

export default api;
